module.exports = __webpack_public_path__ + "static/media/prize-ttn.df333fe2.png";